export type ButtonChooserItem = { key: string; description: string }

export type ButtonChooserCloseEvent =
  | { kind: 'choose'; key: string }
  | { kind: 'dismiss' }

/**
 * Swing `Messages.showButtonChooser`: variants are `[[key, label], ...]`.
 */
export function mapButtonChooserArrayItems(variants: unknown): ButtonChooserItem[] {
  if (!Array.isArray(variants)) return []
  return variants.map((variant) => {
    const row = Array.isArray(variant) ? variant : []
    const rawKey = row[0]
    const rawDescription = row[1] ?? rawKey
    return {
      key: String(rawKey ?? ''),
      description: String(rawDescription ?? ''),
    }
  })
}

/**
 * Swing: click a variant button → that key; close via X / mask → null.
 * No OK/Cancel footer (unlike `showChooser`).
 */
export function resolveButtonChooserChoice(event: ButtonChooserCloseEvent): string | null {
  return event.kind === 'choose' ? event.key : null
}
